import React from "react";
import { BarChart } from "lucide-react";

const ExpectedReturnMetric = ({ trades, userSettings }) => {
  const calculateAdjustedPnL = (trade) => {
    if (!userSettings?.useCommissions) return trade.pnl;

    const commissionCost = userSettings.commissionValue * trade.quantity * 2;
    return trade.pnl - commissionCost;
  };

  const calculateExpectedReturn = (trades) => {
    if (!trades || trades.length === 0) return null;

    const validTrades = trades.filter((trade) => typeof trade.pnl === "number");
    if (validTrades.length === 0) return null;

    const totalTrades = validTrades.length;
    const winningTrades = validTrades.filter(
      (trade) => calculateAdjustedPnL(trade) > 0
    );
    const losingTrades = validTrades.filter(
      (trade) => calculateAdjustedPnL(trade) <= 0
    );

    const winRate = winningTrades.length / totalTrades;
    const lossRate = losingTrades.length / totalTrades;

    const avgWin =
      winningTrades.length > 0
        ? winningTrades.reduce(
            (sum, trade) => sum + calculateAdjustedPnL(trade),
            0
          ) / winningTrades.length
        : 0;

    const avgLoss =
      losingTrades.length > 0
        ? Math.abs(
            losingTrades.reduce(
              (sum, trade) => sum + calculateAdjustedPnL(trade),
              0
            ) / losingTrades.length
          )
        : 0;

    const expectedReturn = winRate * avgWin - lossRate * avgLoss;

    return expectedReturn;
  };

  const formatCurrency = (value) => {
    if (!value && value !== 0) return "$ --";
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  };

  const expectedReturn = calculateExpectedReturn(trades);

  return (
    <div className="metric-card">
      <div className="metric-header">
        <h3>Expected Return</h3>
        <BarChart size={20} className="metric-icon" />
      </div>
      <div className="metric-content">
        {expectedReturn !== null ? (
          <>
            <span
              className={`metric-value ${
                expectedReturn >= 0 ? "profit" : "loss"
              }`}
            >
              {formatCurrency(expectedReturn)}
            </span>
            <span className="metric-subtitle">Implied Return Each Trade</span>
          </>
        ) : (
          <span
            className="metric-subtitle"
            style={{ color: "var(--text-secondary)" }}
          >
            Add trades to see expected return
          </span>
        )}
      </div>
    </div>
  );
};

export default ExpectedReturnMetric;
